import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '../config/constants';
import { LEVELS } from '../data/levels';
import { SaveData } from '../systems/SaveData';
import { Sfx } from '../systems/Sfx';
import { Music } from '../systems/Music';

export class LevelSelectScene extends Phaser.Scene {
  constructor() {
    super('LevelSelect');
  }

  create(): void {
    Music.play('menu');

    this.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 2, 'bg_christmastown');

    this.add
      .text(GAME_WIDTH / 2, 70, 'Select a Level', {
        fontFamily: 'Georgia, serif',
        fontSize: '48px',
        color: '#ffffff',
        stroke: '#2e2a38',
        strokeThickness: 6
      })
      .setOrigin(0.5);

    const unlockedId = SaveData.getUnlockedLevelId();

    // Grid layout so the node count can grow past what fits in a single row.
    const cols = Math.min(5, LEVELS.length);
    const rows = Math.ceil(LEVELS.length / cols);
    const marginX = 150;
    const topY = 190;
    const bottomY = GAME_HEIGHT - 90;
    const spacingX = cols > 1 ? (GAME_WIDTH - marginX * 2) / (cols - 1) : 0;
    const spacingY = rows > 1 ? (bottomY - topY) / (rows - 1) : 0;

    LEVELS.forEach((level, i) => {
      const col = i % cols;
      const row = Math.floor(i / cols);
      const x = marginX + col * spacingX;
      const y = topY + row * spacingY;
      const unlocked = level.id <= unlockedId;
      const isCurrent = level.id === unlockedId;
      const result = SaveData.getLevelResult(level.id);

      const node = this.add.image(x, y, unlocked ? 'node_unlocked' : 'node_locked');

      if (unlocked) {
        this.add
          .text(x, y, String(level.id), {
            fontFamily: 'Arial',
            fontSize: '24px',
            color: '#2e2a38',
            fontStyle: 'bold'
          })
          .setOrigin(0.5);
      }

      this.add
        .text(x, y + 56, level.name, {
          fontFamily: 'Arial',
          fontSize: '13px',
          color: '#ffffff'
        })
        .setOrigin(0.5);

      if (result) {
        for (let s = 0; s < 3; s++) {
          this.add
            .image(x + (s - 1) * 16, y - 54, s < result.stars ? 'ui_star_filled' : 'ui_star_empty')
            .setScale(0.28);
        }
      } else if (isCurrent) {
        this.tweens.add({ targets: node, scale: { from: 1, to: 1.1 }, yoyo: true, repeat: -1, duration: 550 });
      }

      if (unlocked) {
        node.setInteractive({ useHandCursor: true });
        node.on('pointerover', () => node.setScale(1.08));
        node.on('pointerout', () => node.setScale(1));
        node.on('pointerdown', () => {
          Sfx.buttonTap();
          this.scene.start('Game', { levelId: level.id });
        });
      }
    });

    this.createBackButton();
  }

  private createBackButton(): void {
    const back = this.add
      .text(60, 40, '< Back', { fontFamily: 'Arial', fontSize: '22px', color: '#ffffff' })
      .setInteractive({ useHandCursor: true });
    back.on('pointerdown', () => {
      Sfx.buttonTap();
      this.scene.start('MainMenu');
    });
  }
}
